import { render, staticRenderFns } from "./PicTextContentItem.vue?vue&type=template&id=3a156884&scoped=true"
import script from "./PicTextContentItem.vue?vue&type=script&lang=js"
export * from "./PicTextContentItem.vue?vue&type=script&lang=js"
import style0 from "./PicTextContentItem.vue?vue&type=style&index=0&id=3a156884&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a156884",
  null
  
)

export default component.exports